<template>
  <div class="row">
    <div class="col-lg-12">
      <table class="table table-bordered table-hover">
        <thead>
        <tr>
          <th>Task</th>
          <th>Status</th>
          <th>Created</th>
          <th>By</th>
          <th>Updated</th>
          <th>Type</th>
          <th>Assignee</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="task in tasks" :key="task.id">
          <td>
            <router-link :to="'/maintenance/task/' + task.id">{{ task.title }}</router-link>
            <i class="fa fa-comment" v-tooltip="task.description"></i>
            <br>
            <span v-for="tag in task.tags" :key="'task-tag-' + task.id + tag" class="label label-info m-r-sm">{{ tag }}</span>
          </td>
          <td>{{ task.status }}</td>
          <td>{{ task.created | aTime('from') }}</td>
          <td>{{ task.creator ? task.creator.name : 'System' }}</td>
          <td>{{ task.updated | aTime('from') }}</td>
          <td>{{ task.type }}</td>
          <td>{{ task.assignee ? task.assignee.name : '/' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-9"></div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      tasks: []
    }
  },
  computed: {
    ...mapGetters({
      pbn: 'getPbn'
    })
  },
  mounted () {
    this.loadTasks()
  },
  methods: {
    loadTasks () {
      axios.get(`/maintenance/tasks?pbn=${this.pbn.id}`)
        .then(r => {
          this.tasks = r.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Tasks.vue